import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  GoogleMap,
  useJsApiLoader,
  Autocomplete,
  Marker,
  LoadScript,
  useLoadScript,
  DirectionsRenderer,
} from "@react-google-maps/api";
import styled from "styled-components";
import { useState } from "react";
import locationData from "../../utils/locationData/locationOptions";
import { useDispatch } from "react-redux";
import axios from "axios";
import {
  setDefaultRouteState,
  setRouteDistance,
  setSelectedItem,
  setUpdateRouteMap,
  updateRouteItem,
} from "../../features/addLoad/addLoadSlice";
import LoadMapInputs from "../load/loadMapInputs/LoadMapInputs";
import { useMemo } from "react";
import Button from "../shared/Button";
import PageTopTitle from "../shared/PageTopTitle";
import { closeAllModal, showNestedModal } from "../../features/modal/modalSlice";
import AddMapRoute from "../load/sections/shared/others/AddMapRoute";
import Btn from "../shared/button/Btn";


const Container = styled.div`
  width: 100%;
  height: 100%;

  .pop-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow: auto;
    margin-top: 20px;
    .input-container {
      width: 40%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-right: 50px;
      .add-routes{
        display: grid ;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
      }
      .locations {
        display: flex;
        width: 100%;
        margin-block: 10px;
        align-items: flex-start;
        padding: 20px;
        justify-content: space-between;
        flex-direction: column;
        .delete-btn{
          display: flex;
          margin-bottom: 10px;
          padding: 5px;
          font-size: 14px;
          border-radius: 8px;
          background-color: var(--color-light);
        }
        p{
          width: 100%;
          font-weight: 600;
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          span{
            font-weight: 400;
            margin-top: 5px;
          }
        }
        .opt-list {
          position: absolute;
          top: 50%;
          height: 150px;
          width: 90%;
          overflow: auto;
          z-index: 999;
           border: 1px solid gray;
          border-radius: 10px;
          background: white;
          padding: 10px;
          left: 5%;

          .opt-item {
            display: flex;
            margin-block: 5px;
          }
        }
      }
      input {
        width: 100%;
        border: 1px solid gray;
        border-radius: 8px;
        height: 40px;
        padding: 10px;
      }
    }
  }
  .map-side{
    display: flex;
    flex-direction: column;
    .map-container {
      width: 1000px;
      height: 600px;
    }
    .buttons{
      margin-top: 15px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 15px;
    }
  }

  .selected {
    background-color: white;
    border: 2px solid var(--color-main);
    border-radius: 8px;
    padding: 10px;
    position: relative;

  }
`;



const SelectLoadMap = () => {
  const { route, routeItem, selectedItem, defaultRouteState } = useSelector((state) => state.addLoad);
  const [map, setMap] = useState(null);
  const memoRoute = useMemo(() => route, []);
  const dispatch = useDispatch();
  const [directionsResponse, setDirectionsResponse] = useState(null);

  const filterRoute = route.filter(item => item.locationType === "yukleme")

  useEffect(() => {
   // Burada routeItem'ı selectedItem içine atıyoruz, eğer routeItem null değilse
    if (routeItem) {
      dispatch(setSelectedItem(routeItem));
    }
  }, [dispatch, routeItem]);


  //! google map api ile haritadan seçerek konum ekleme
  const handleClick = async (e) => {
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();

    try {
      const { data } = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`)
      const adres = data?.results[0]?.formatted_address;
      const found = findLocationFromAddress(locationData, adres);

      handleUpdateFunction({
        id: selectedItem?.id,
        adres:adres,
        il: found?.city,
        ilce: found?.town,
        location: found?.location,
        lat: found?.lat,
        lng: found?.lng,
        bolge: found?.region,
        ilId: found?.cityId,
        ilceId: found?.townId,
      });
    } catch (error) {
      console.error("Adres dönüştürme hatası: ", error);
    }
  };

  const findLocationFromAddress = (data, address) => {
    return data?.find((item) => {
      return address?.includes(item?.city) && address?.includes(item?.town);
    });
  };

  const handleUpdateFunction = ({ id, il, ilce, location, bolge, ilId, ilceId, lat, lng, adres}) => {
    const updatedItem = {
      id: id,
      adres:adres,
      locationData: {
        il: il,
        ilce: ilce,
        location: location,
        bolge: bolge,
        lat: lat,
        lng: lng,
        ilceId: ilceId,
        ilId: ilId,
      },
    };
    dispatch(updateRouteItem(updatedItem));
  };

  //! Harita üzerinde işaretlemelerin yapıldığı bölüm

  const rotaOptions = {
    polylineOptions: {
      strokeColor: "#BB2649",
      strokeOpacity: 1.0,
      strokeWeight: 5,
    },
  };

  useEffect(() => {
    const list = route.filter((item) => item?.locationData?.lng && item?.locationData?.lat);
    if (map && list.length > 1) {
      calculateRoute(list);
    }
  }, [map, route]);

  const calculateRoute = async (route) => {
    try {
      // eslint-disable-next-line no-undef
      const origin = {
        lat: parseFloat(route[0]?.locationData?.lat),
        lng: parseFloat(route[0]?.locationData?.lng),
      };
      // eslint-disable-next-line no-undef
      const destination = {
        lat: parseFloat(route[route.length - 1]?.locationData?.lat),
        lng: parseFloat(route[route.length - 1]?.locationData?.lng),
      };
      // eslint-disable-next-line no-undef
      const wayPoints = route.slice(1, route.length - 1).map((waypoint) => {
        return {
          location: {
            lat: parseFloat(waypoint?.locationData?.lat),
            lng: parseFloat(waypoint?.locationData?.lng),
          },
        };
      });

      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService();
      const results = await directionsService.route({
        origin: origin,
        destination: destination,
        // eslint-disable-next-line no-undef
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: wayPoints.length > 0 ? wayPoints : null,
      });
      setDirectionsResponse(results);

      dispatch(
        setRouteDistance(
          results.routes[0].legs.reduce((accumulator, item) => {
            return (
              accumulator + parseFloat(item.distance.text.replace(".", ""))
            );
          }, 0)
        )
      );
    } catch (error) {
      // console.log("Route calculation error:", error);
    }
  };

  useEffect(()=>{
      dispatch(setDefaultRouteState(memoRoute))
  },[dispatch])

  const handleSave=()=>{
    dispatch(setUpdateRouteMap(route))
    dispatch(closeAllModal())
  }

  const handleCancel=()=>{
    dispatch(showNestedModal("MapChanges"))
  }

  const handleLocationClick = (clicked) => {
    dispatch(setSelectedItem(clicked));
  };

 

  return (
    <Container>
      <PageTopTitle title={"Haritadan Seçim Yapınız"}/>
      <div className="pop-container">
        {/* <div className="input-container">
          <div className="add-routes">
            <AddMapRoute order={filterRoute.length + 1} SelectLoadMap type="yukleme" />
            <AddMapRoute order={filterRoute.length + 1} SelectLoadMap type="bosaltma" />
          </div> 

          {route.map((item, index) => {
            return (
              <>
                <LoadMapInputs
                  handleClick={handleClick}
                  item={item}
                  selectedItem={selectedItem}
                  onClick={() => handleLocationClick(item)}
                  index={index}
                  locationData={locationData}
                />
              </>
            );
          })}      
        </div> */}
        <div className="map-side">
          <GoogleMap
            mapContainerClassName="map-container"
            onClick={handleClick}
            zoom={5.5}
            center={{ lat: 38.75, lng: 33.75 }}
            onLoad={(mapInstance) => setMap(mapInstance)}
          >
            {directionsResponse && (
              <DirectionsRenderer
                directions={directionsResponse}
                options={rotaOptions}
              />
            )}
          </GoogleMap>
          <div className="buttons">
            <Btn handleClick={handleSave} color={"#E85446"} bgColor={"transparent"} width="100%">Kaydet</Btn>
            <Btn handleClick={handleCancel} color={"#fff"} bgColor={"#E85446"} width="100%">Kapat</Btn>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SelectLoadMap;
